// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__25WI5","container":"styles_container__2yP7e","title":"styles_title__2A95a","wrapper":"styles_wrapper__1iyf6","answer":"styles_answer__1kfTc"};